export function getInputId(fieldId) {
  return "form-field-input-" + fieldId;
}
export function getLabelId(fieldId) {
  return "form-field-label-" + fieldId;
}
//# sourceMappingURL=field-attributes.js.map